import React from 'react'
import TitleBar from '../TitleBar'
import getLabel from '../../utilities/label.js'

export default function ForgotPasswordForm(props){
  return (
    <div>
      <TitleBar title={ getLabel('request_password') } />
      <form>
        <div className='form-group input-wrapper'>
          <input
            defaultValue={ localStorage.email ? localStorage.email : ''}
            type='text'
            className='form-control'
            id='email'
            placeholder={ getLabel('username') }
            onChange={ props.changeEmail } />
        </div>
        <button
          onClick={ props.submitForgot }
          className='submit-button margin-top-10'>
          { getLabel('submit') }
        </button>
        <button
          className='cancel-button'
          onClick={ props.cancel } >
          { getLabel('cancel')}
        </button>
      </form>
    </div>
  )
}
